import {
  emptyDraft,
  type PasswordChangeDraft,
  type PasswordValidationErrors,
  type SubmitStatus,
} from '../domain/password-change.model';
import type { PasswordChangeError } from '../domain/password-change-error';

/**
 * Redux state for the password-change form.
 *
 * `open` lives here rather than in component state because the section's two
 * shapes are one state machine with the submit: a successful change closes the
 * form, and the saga is what knows it succeeded. Splitting them would mean the
 * saga reaching into a component.
 *
 * `revokedSessions` is the count the backend returned; held only long enough
 * for the page to phrase the success message, then cleared with the rest.
 */
export interface PasswordChangeState {
  open: boolean;
  draft: PasswordChangeDraft;
  submitStatus: SubmitStatus;
  validationErrors: PasswordValidationErrors;
  error: PasswordChangeError | null;
  revokedSessions: number | null;
}

export const initialState: PasswordChangeState = {
  open: false,
  draft: emptyDraft,
  submitStatus: 'idle',
  validationErrors: {},
  error: null,
  revokedSessions: null,
};
